var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.139379 11.9124V11.7079C0.174295 11.0531 0.380951 10.4187 0.738838 9.86772C1.3356 9.19908 1.74585 8.38691 1.92881 7.51191C1.97355 6.84518 1.92881 6.16066 1.97355 5.48503C2.29564 2.24024 5.50767 0 8.5855 0H8.67497C11.8065 0 14.938 2.24024 15.278 5.48503C15.3406 6.15177 15.278 6.84518 15.3317 7.51191C15.5102 8.38844 15.921 9.20171 16.5216 9.86772C16.8951 10.4124 17.1088 11.0495 17.139 11.7079V11.9124C17.1445 12.7993 16.8267 13.6582 16.2443 14.3304C15.4971 15.1274 14.4815 15.624 13.3901 15.7261C10.2033 16.135 6.97669 16.135 3.78982 15.7261C2.71117 15.6157 1.70962 15.1197 0.971464 14.3304C0.407325 13.6518 0.111498 12.7921 0.139379 11.9124Z",
    fill: "#8A92A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80227 17.0952C9.16702 17.0507 8.64808 17.0952 8.12915 17.0952C7.6145 17.0863 7.10069 17.14 6.59918 17.2552C6.16972 17.353 5.70447 17.5841 5.70447 18.0731C5.74953 18.5456 6.0057 18.9731 6.40235 19.2376C7.1664 19.8212 8.12924 20.0858 9.08649 19.9755C10.017 19.9069 10.8675 19.4273 11.4038 18.6687C11.7003 18.2844 11.6326 17.735 11.2517 17.433C10.8006 17.2125 10.305 17.097 9.80227 17.0952Z",
    fill: "#8A92A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.02a3f9225e5284bea8b6dae3cdc6ca87.svg";
export { ForwardRef as ReactComponent };